/**
 * Mathematical functions
 */
const isOdd = (number: string | number) => {
  if (typeof number === 'string') {
    return parseInt(number) % 2 !== 0;
  }
  return number % 2 !== 0;
};

const isEven = (number: string | number) => {
  if (typeof number === 'string') {
    return parseInt(number) % 2 === 0;
  }
  return number % 2 === 0;
};

export { isOdd, isEven };
